/** Clear multiple slashes. */
export const clearUrl = (url: string) => url.replace(/([^:])\/\/+/g, '$1/');
